































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Actions, UserTypes } from '@/ts/store/Constants';
import PersonData from '@/ts/PersonData';
import UserRoleData from '@/ts/UserRoleData';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';

@Component
export default class MobileUserInfoConnectedUsers extends Mixins(LocalizationMethods) {
    @Prop() public userId!: number;

    get userData(): PersonData {
        return this.$store.getters['User/getCacheUser'](this.userId);
    }

    get userRole(): UserRoleData {
        return this.$store.getters['User/getCacheRole'](this.userData.roleId);
    }

    get typeClass(): object {
        return {
            'hococo-connected-users-property-adminstrator': (this.userRole.key === UserTypes.ADMINISTRATOR),
            'hococo-connected-users-property-owner': (this.userRole.key === UserTypes.PROPERTY_OWNER),
        };
    }

    get phoneNumber(): string {
        if (!this.userData.phoneNumber) {
            return '';
        }

        return 'tel:' + this.userData.phoneNumber.toString();
    }

    get translatedFunctionDescription() {
        let translatedDescription = null;

        if (this.userData.translations) {
            translatedDescription = this.userData.translations.find((translation: any) => translation.language_id === this.currentLocalizationObject.id);
        }

        return translatedDescription
            ? translatedDescription.description
            : this.userData.functionDescription;
    }

    public directMessage() {
        if (!this.userData.isTenantContactableByMessage) {
            return false;
        }

        this.$store.dispatch(Actions.INITIALIZE_DIRECT_CONVERSATION, this.userId);

        return true;
    }
}

